import { MembersSheetContent } from "./MembersSheetContent";
import { CommunicationSheetContent } from "./CommunicationSheetContent";
import { ClassCheckInSheetContent } from "./ClassCheckInSheetContent";
import {
  AtRiskMembers,
  CelebrationsMetadata,
  CelebrationsProfile,
  ExpiringMembers,
  NewLeads,
  NewMemberships,
  OpenInvoices,
  SubscriptionCancelRequest,
} from "../../../apis/metricsApi";
import { ScheduleItem } from "../MySchedule/useDailySchedule";

export type MemberSheetDataType =
  | { type: "openInvoices"; data: OpenInvoices[] }
  | { type: "atRiskMembers"; data: AtRiskMembers[] }
  | { type: "expiringMembers"; data: ExpiringMembers[] }
  | { type: "newLeads"; data: NewLeads[] }
  | { type: "newMemberships"; data: NewMemberships[] }
  | { type: "cancelRequests"; data: SubscriptionCancelRequest[] };

export type MemberSheetDataDataType =
  | OpenInvoices
  | AtRiskMembers
  | ExpiringMembers
  | NewLeads
  | NewMemberships
  | SubscriptionCancelRequest;

export type CommunicationsSheetData = {
  celebrations?: CelebrationsProfile[];
  celebrationsMetadata?: CelebrationsMetadata[];
};

export type ClassCheckinSheetData = {
  isMultiClass: boolean;
  classScheduleItem?: ScheduleItem;
};

export type SheetType = "members" | "communications" | "classCheckin";

export type SheetDataMap = {
  members: MemberSheetDataType;
  communications: CommunicationsSheetData;
  classCheckin: ClassCheckinSheetData;
};

export type BaseSheetProps = {
  title?: string;
  reportUrl?: string;
};

export type MembersSheetProps = BaseSheetProps & {
  data: MemberSheetDataType;
};

export type CommunicationsSheetProps = BaseSheetProps & {
  data: CommunicationsSheetData;
};

export type ClassCheckinSheetProps = BaseSheetProps & {
  data?: ClassCheckinSheetData;
};

export const SheetComponents: {
  members: React.FC<MembersSheetProps>;
  communications: React.FC<CommunicationsSheetProps>;
  classCheckin: React.FC<ClassCheckinSheetProps>;
} = {
  members: MembersSheetContent,
  communications: CommunicationSheetContent,
  classCheckin: ClassCheckInSheetContent,
};

export type SheetContent = {
  title: string;
  children: React.ReactNode;
};
